/**
 * Two themes, dark settled. The storage key is **shared with the two sibling
 * frontends** so one theme choice survives the hop between hosts; the
 * navigation key below is deliberately area-scoped, because an operator's
 * console navigation and a viewer's dashboard navigation are different
 * navigations and letting one collapse the other is a state leak (PRD-TDD §9).
 */

export const THEMES = ['dark', 'light'] as const;

export type Theme = (typeof THEMES)[number];

export const DEFAULT_THEME: Theme = 'dark';

/** Shared across all three frontends. */
export const THEME_STORAGE_KEY = 'shahedni-theme';

/** This console only. */
export const NAV_STORAGE_KEY = 'shahedni-admin-nav';

export function isTheme(value: unknown): value is Theme {
  return typeof value === 'string' && (THEMES as readonly string[]).includes(value);
}
